'use strict';

(function () {
  angular
    .module('specsguardApp')
    .controller('sgAttachmentsController', sgAttachmentsController);

  sgAttachmentsController.$inject = ['$scope', 'Labels'];

  function sgAttachmentsController ($scope, Labels) {
    const vm = this;
    vm.$onInit = () => {
      addUriEncodedPaths(vm.attachments);

      vm.carousel = vm.carousel || false;
      vm.selected = 0;
    };

    vm.$onChanges = (changesObj) => {
      if (changesObj.attachments && angular.isArray(changesObj.attachments.previousValue)) {
        addUriEncodedPaths(changesObj.attachments.currentValue);
      }
    };

    function addUriEncodedPaths (attachments) {
      if (attachments && attachments.length){
        for (const attachment of attachments) {
          attachment.uriEncodedPath = encodeURI(attachment.path)
            .replace(/\(/g, '\\(')
            .replace(/\)/g, '\\)');
        }
      }
    }

    vm.LABELS = Labels;

    vm.isImage = function (file) {
      return file.file.type.startsWith('image');
    };

    vm.images = function () {
      const images = [];
      let index = 0;
      for (const attachment of vm.attachments) {
        if (vm.isImage(attachment)) {
          attachment.selected = index === vm.selected;
          images.push(attachment);

          index += 1;
        }
      }

      return images;
    };

    vm.hasImages = function () {
      const images = vm.images();
      return images && images.length > 0 || false;
    };

    vm.change = function (delta) {
      vm.selected += delta;
    };
  }
})();
